export default "__VITE_ASSET__fa70b8ab__"